import * as React from "react";
import { connect } from "react-redux";
import Login from "../../screens/Login";
import { login, logOut } from "./actions";
export interface Props {
  logins: any;
}

export interface State { }
class LoginSection extends React.Component<Props, State> {
  render() {
    return <Login logins={this.props.logins}
      logOutAction={this.props.logOutAction} />;
  }
}
function bindAction(dispatch) {
  return {
    logins: (value) => {
      // console.log("index============", value);
      dispatch(login(value));
    },
  };
}
const mapStateToProps = (state) => ({});

export default connect(mapStateToProps, bindAction)(LoginSection);
